import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";

import FormInput from "components/atoms/input/FormInput";

import AbstractModal from "components/page/modal/AbstractModal";

import { useResearchCreate } from "hooks/queries/useResearch";
import { useUser } from "hooks/queries/useUser";

import { genericEnterKeyDown } from "utils/validation";

const Container = styled.div`
    width: 100%;
`;

function ResearchAddModal(props) {
    const [displayName, setDisplayName] = useState("");
    const inputRef = useRef(null);
    const researchMutation = useResearchCreate();
    const userQuery = useUser();
    const [user, setUser] = useState({});

    useEffect(() => {
        if (userQuery.data) {
            setUser(userQuery.data);
        }
    }, [userQuery.data]);

    const addResearch = () => {
        researchMutation.mutate(
            {
                display_name: displayName,
                ai_response_language: user.env_ai_language,
                citation_style: user.env_citation_style,
            },
            {
                onSuccess: (data) => {
                    props.onSuccess(data);
                },
                onError: (error) => {
                    console.log(error);
                },
            },
        );
    };

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    return (
        <AbstractModal
            modalTitle="연구노트 추가"
            width={480}
            exitModal={props.exitModal}
            footer={{
                leftBtnText: "취소",
                rightBtnText: "확인",
                leftOnClick: props.exitModal,
                rightOnClick: addResearch,
            }}
        >
            <Container>
                <FormInput
                    labelDp="none"
                    placeholder="제목을 입력하세요."
                    value={displayName}
                    onChange={(e) => setDisplayName(e.target.value)}
                    onKeyDown={(e) => {
                        genericEnterKeyDown(e, addResearch);
                    }}
                    ref={inputRef}
                />
            </Container>
        </AbstractModal>
    );
}

export default ResearchAddModal;
